import React from "react";
import Header from "../../layout/Header";

const PageNotFound = () => {
  return (
    <>
      <Header />
      <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-white px-4 pt-16 -mt-16">
        <div className="text-center animate-fadein">
          <div className="mb-8 relative">
            <svg
              className="mx-auto w-44 h-44 md:w-60 md:h-60 animate-bounce-slow"
              viewBox="0 0 250 250"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <ellipse
                cx="125"
                cy="125"
                rx="120"
                ry="120"
                fill="#eef2ff"
                stroke="#2563eb"
                strokeWidth="4"
              />
              <text
                x="50%"
                y="54%"
                textAnchor="middle"
                fill="#2563eb"
                fontSize="70"
                fontWeight="bold"
                dominantBaseline="middle"
                className="animate-glow"
              >
                404
              </text>
              <circle
                cx="87"
                cy="105"
                r="7"
                fill="#2563eb"
                opacity="0.85"
                className="animate-pulse"
              />
              <circle
                cx="163"
                cy="105"
                r="7"
                fill="#2563eb"
                opacity="0.85"
                className="animate-pulse"
              />
              <path
                d="M95 170 Q125 200 155 170"
                stroke="#2563eb"
                strokeWidth="5"
                fill="none"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <h3
            className="text-4xl md:text-4xl  text-black mb-4"
            style={{
              color: "black!important",
            }}
          >
            Oops! Page Not Found
          </h3>
          <p className="text-gray-600 text-lg md:text-xl mb-6">
            The page you are looking for doesn&apos;t exist or has been moved.
          </p>
          <a
            href="/"
            className="inline-block px-8 py-3 rounded-md bg-[#2563eb] text-white font-semibold text-lg shadow-md hover:bg-[#1747a3] transition duration-200 animate-in"
          >
            Go Home
          </a>
        </div>
        {/* Animations CSS */}
        <style>{`
          .animate-fadein {
            animation: fadein 0.9s cubic-bezier(.4,0,.2,1);
          }
          @keyframes fadein {
            0% { opacity: 0; transform: translateY(30px);}
            100% { opacity: 1; transform: translateY(0);}
          }
          .animate-bounce-slow {
            animation: bounce-slow 2.3s infinite alternate;
          }
          @keyframes bounce-slow {
            0% { transform: translateY(0);}
            100% { transform: translateY(-14px);}
          }
          .animate-glow {
            filter: drop-shadow(0 0 15px #bdd8ff);
          }
          .animate-in {
            animation: fade-down .9s cubic-bezier(.61,.31,0,1.01);
          }
          @keyframes fade-down {
            0% { opacity: 0; transform: translateY(-26px);}
            100% { opacity: 1; transform: translateY(0);}
          }
        `}</style>
      </div>
    </>
  );
};

export default PageNotFound;
